import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// 样式
import './assets/css/index.scss';

// Element组件及国际化
import './plugins/element.js';

// 百舸云组件
import './plugins/baiGeYun.js';

// 自定义工具方法
import './utils/index.js';

// 校验权限方法
import checkBtnPermission from '@/utils/checkBtnPermission.js';
Vue.prototype.$checkBtnPermission = checkBtnPermission;

// 注册全局自定义指令
import * as directives from '@/directives';
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
});

Vue.directive('drag', {
  bind: function (el, binding) {
    let op = el; //当前元素
    let self = this; //上下文
    op.onmousedown = function (e) {
      //鼠标按下，计算当前元素距离可视区的距离
      let disX = e.clientX - op.offsetLeft;
      let disY = e.clientY - op.offsetTop;

      document.onmousemove = function (e) {
        //通过事件委托，计算移动的距离
        let l = e.clientX - disX;
        let t = e.clientY - disY;
        //移动当前元素
        op.style.left = l + 'px';
        op.style.top = t + 'px';
      };
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
        //将此时的位置传出去
        binding.value({ action: 'up', x: e.pageX, y: e.pageY });
      };
      binding.value({ action: 'down', x: e.pageX, y: e.pageY });
    };
  }
});

// 注册全局过滤器
import * as filters from '@/filters';
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// 引入Lodash
import _ from 'lodash';
Vue.prototype.$_ = _;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
